<table class="table" mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>Selecionar</th>
    <td mat-cell *matCellDef="let element">
      <mat-radio-button
        (click)="$event.stopPropagation()"
        (change)="$event ? handleSelect(element) : null">
      </mat-radio-button>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container *ngFor="let coluna of colunas; let first = first">
    <ng-container [matColumnDef]="coluna.name">
      <th mat-header-cell *matHeaderCellDef>{{ coluna.label }}</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="getIcon(element, coluna)" [ngClass]="getIconClass(element, coluna)">
          {{ getIcon(element, coluna) }}
        </mat-icon>

        <span [matTooltip]="coluna.truncate ? getValue(element, coluna, true) : ''">
          {{ getValue(element, coluna) }}
        </span>

        <ng-container *ngIf="coluna.acoes && hasAcoes(element, coluna.acoes)">
          <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <ng-container *ngFor="let acao of coluna.acoes">
              <button mat-menu-item 
                (click)="acao.action(element)" 
                [disabled]="getAcaoDisabled(element, acao)"
                *ngIf="!getAcaoHidden(element, acao)"
              >
                <mat-icon>{{ getAcaoIcon(element, acao) }}</mat-icon>
                <span>{{ getAcaoLabel(element, acao) }}</span>
              </button>
            </ng-container>
          </mat-menu>
        </ng-container>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <span class="table-footer-label" *ngIf="footerLabel && first">
          {{ footerLabel }}:
        </span>
        <ng-container *ngIf="getFooterColumn(coluna.name)?.total">
          {{ getTotal(getFooterColumn(coluna.name)!) }}
        </ng-container>
      </td>
    </ng-container>
  </ng-container>
  
  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns" [style.display]="(footerColumns && footerColumns.length > 0) ? '' : 'none'"></tr>
</table>